import { render } from "./Creators.vue?vue&type=template&id=389a6dc0"
import script from "./Creators.vue?vue&type=script&lang=js"
export * from "./Creators.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__